import { render, staticRenderFns } from "./orgStructure.vue?vue&type=template&id=28087e1c&scoped=true&"
import script from "./orgStructure.vue?vue&type=script&lang=js&"
export * from "./orgStructure.vue?vue&type=script&lang=js&"
import style0 from "./orgStructure.vue?vue&type=style&index=0&id=28087e1c&prod&lang=css&"
import style1 from "./orgStructure.vue?vue&type=style&index=1&id=28087e1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28087e1c",
  null
  
)

export default component.exports